import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=5633b473&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633b473",
  null
  
)

export default component.exports